import { SvgIcon } from '../icons'

import * as styles from './number-icon.styles'

type Props = {
  value: number
  className?: string
}

export const NumberIcon = ({ value, className }: Props) => (
  <SvgIcon className={className} css={styles.root} data-testid="number-icon">
    <circle
      cx="12"
      cy="12"
      fill="none"
      r="11"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <text css={styles.text} textAnchor="middle" x={12} y={16}>
      {value}
    </text>
  </SvgIcon>
)
